import styled from 'styled-components';

export const CheckoutComplete = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 20px;
  font-size: 16px;
  margin-top: 32px;
  padding-top: 139px;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: flex-start;
  border-top: 1px solid #EBEDF2;
  @media(max-width: 426px) {
    padding-top: 6vh;
    font-size: 14px;
  }
`;

export const Title = styled.span`
  font-family: 'Proxima Nova';
  letter-spacing: -0.02em;
  margin-bottom: 8px;
  align-items: center;
  text-align: center;
  font-style: normal;
  line-height: 120%;
  font-weight: 600;
  font-size: 1.5em;
  color: #2B323B;
  display: flex;
`;

export const Subtitle = styled.span`
  display: flex;
  font-size: 1em;
  font-weight: 400;
  color: #38424D;
  line-height: 120%;
  font-style: normal;
  text-align: center;
  margin-bottom: 42px;
  align-items: center;
  font-family: 'Proxima Nova';
`;

export const ExpirationLabel = styled.span`
  width: 100%;
  display: flex;
  font-weight: 600;
  color: #2B323B;
  font-size: 1.25em;
  line-height: 120%;
  font-style: normal;
  text-align: center;
  margin-bottom: 11px;
  font-family: 'Proxima Nova';
`;

export const ExpirationContainer = styled.div`
  border: 1px solid #EBEDF2;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 131px;
  flex-direction: row;
  align-items: center;
  max-width: 472px;
  display: flex;
  padding: 24px;
  height: 112px;
  width: 472px;
  @media(max-width: 1190px) {
    padding: 12px;
    width: calc(100% + 52px);
  }
`;

export const DateContainer = styled.div`
  &:first-child {
    margin-right: 38px;
  }  
  &:last-child {
    margin-left: 38px;
  }
  @media(max-width: 1190px) {
    &:first-child {
    margin-right: 7%;
    }  
    &:last-child {
      margin-left: 7%;
    }
  }
`;

export const Expiration = styled.span`
  font-family: 'Proxima Nova';
  align-items: center;
  margin-bottom: 4px;
  font-style: normal;
  line-height: 120%;
  color: #607184;
  font-weight: 400;
  font-size: 1em;
  display: flex;
`;

export const Date = styled.span`
  font-family: 'Proxima Nova';
  letter-spacing: -0.02em;
  font-style: normal;
  line-height: 120%;
  color: #000000;
  font-weight: 600;
  font-size: 1.5em;
  @media(max-width: 1190px) {
    font-size: 1.25em;
  }
  @media(max-width: 700px) {
    font-size: 1.375em;
  }
`;

export const CompletePurchaseWrapper = styled.div`
  width: 472px;
  margin-bottom: 8px;
  @media(max-width: 1190px) {
    width: 100%;
  }
  @media(max-width: 701px) {
    max-width: 472px;
  }
`;
